import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const NavigationBoldRightIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M6 12L10 8L6 4' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export default NavigationBoldRightIcon
